import { render, staticRenderFns } from "./Leaving.vue?vue&type=template&id=044e1e90&"
import script from "./Leaving.vue?vue&type=script&lang=js&"
export * from "./Leaving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports